class RegisteredUserData {
  constructor(
    user_Id,
    user_Name,
    token,
    mobile_number,
    email_Id,
    phone,
    gender,
    isPaid,
    ageFrom,
    ageTo,
    isPaidForAstrology
  ) {
    this.user_Id = user_Id;
    this.user_Name = user_Name;
    this.token = token;
    this.mobile_number = mobile_number;
    this.email_Id = email_Id;
    this.phone = phone;
    this.gender = gender;
    this.isPaid = isPaid;
    this.ageFrom = ageFrom;
    this.ageTo = ageTo;
    this.isPaidForAstrology = isPaidForAstrology;
  }
  static fromJson(json) {
    return new RegisteredUserData(
      json.user_Id,
      json.user_Name,
      json.token,
      json.mobile_number,
      json.email_Id,
      json.phone,
      json.gender,
      json.isPaid,
      json.ageFrom,
      json.ageTo,
      json.isPaidForAstrology
    );
  }
}
export default RegisteredUserData;